var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 330,
    viewBox: "0 0 375 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32063e-05 60.1801L0 182.192V330H375V182.192V60.1801C375 60.1801 324.5 36 187.5 36C50.5 36 1.32063e-05 60.1801 1.32063e-05 60.1801Z",
    fill: "#C4E2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9354 24.145C51.4461 25.1219 47.7648 23.2971 46.7134 20.0694C45.6617 16.8414 47.6373 13.4331 51.1267 12.4562C54.6157 11.4793 58.2968 13.3041 59.3487 16.532C60.4004 19.7598 58.4245 23.1683 54.9354 24.145Z",
    fill: "#90C8F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.825 45.3901C352.853 48.6335 350.036 51.2866 346.53 51.3159C343.024 51.3453 340.161 48.7398 340.133 45.4964C340.105 42.2528 342.923 39.6 346.429 39.5706C349.934 39.5413 352.797 42.1465 352.825 45.3901Z",
    fill: "#90C8F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6 7.3968C22.5788 4.93189 24.7207 2.91551 27.3846 2.8932C30.0482 2.87089 32.2249 4.85108 32.2462 7.31601C32.2675 9.78088 30.1252 11.7973 27.4616 11.8196C24.7978 11.8419 22.6213 9.86167 22.6 7.3968ZM31.4847 7.32239C31.4668 5.24665 29.6339 3.57913 27.3907 3.59792C25.1474 3.6167 23.3437 5.3147 23.3616 7.39042C23.3795 9.46605 25.2123 11.1337 27.4555 11.1149C29.6988 11.0961 31.5026 9.39802 31.4847 7.32239Z",
    fill: "#90C8F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37379 57.2875C4.47123 56.1876 1.4646 51.617 2.65847 47.0788C3.85234 42.5407 8.7946 39.7535 13.6974 40.8535C18.6003 41.9534 21.6069 46.5241 20.413 51.0624C19.2191 55.6006 14.2765 58.3877 9.37379 57.2875ZM19.6731 50.8964C20.7674 46.7364 18.0114 42.5469 13.5173 41.5384C9.02308 40.5301 4.49276 43.085 3.39842 47.2451C2.30405 51.4048 5.06008 55.5944 9.55401 56.6026C14.0481 57.6111 18.5787 55.0564 19.6731 50.8964Z",
    fill: "#749BB1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.124 79.4811C357.221 78.3812 354.215 73.8106 355.409 69.2724C356.603 64.7343 361.545 61.9471 366.448 63.0471C371.351 64.147 374.357 68.7177 373.163 73.256C371.969 77.7942 367.027 80.5813 362.124 79.4811ZM372.423 73.09C373.518 68.93 370.762 64.7405 366.268 63.732C361.773 62.7238 357.243 65.2787 356.149 69.4387C355.054 73.5984 357.81 77.788 362.304 78.7962C366.798 79.8047 371.329 77.25 372.423 73.09Z",
    fill: "#749BB1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1951 51.0867C66.847 52.4103 65.4055 53.2233 63.9755 52.9024C62.5457 52.5817 61.6685 51.2486 62.0166 49.9249C62.3649 48.6015 63.8064 47.7883 65.2364 48.109C66.6664 48.4299 67.5434 49.763 67.1951 51.0867Z",
    fill: "#36698D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.52 6.26647C157.532 7.62881 156.347 8.7431 154.876 8.75542C153.404 8.76775 152.201 7.67345 152.189 6.31112C152.177 4.94883 153.361 3.83473 154.833 3.8224C156.305 3.81008 157.508 4.90418 157.52 6.26647Z",
    fill: "#90C8F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.821 14.3611C172.828 15.0745 172.207 15.6583 171.436 15.6648C170.665 15.6713 170.035 15.0979 170.029 14.3845C170.023 13.6711 170.643 13.0873 171.414 13.0808C172.185 13.0744 172.815 13.6477 172.821 14.3611Z",
    fill: "#749BB1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.968 88.0056C272.959 86.9678 272.043 86.134 270.921 86.1434C269.799 86.1528 268.898 87.0018 268.907 88.0396C268.916 89.0775 269.832 89.9113 270.954 89.9019C272.076 89.8925 272.977 89.0434 272.968 88.0056Z",
    fill: "#90C8F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.773 10.6056C368.79 12.6164 367.042 14.2614 364.87 14.2796C362.697 14.2978 360.921 12.6823 360.903 10.6716C360.886 8.66076 362.634 7.01576 364.807 6.99756C366.98 6.97937 368.755 8.59486 368.773 10.6056Z",
    fill: "#36698D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7022 35.4056C38.6219 35.9878 36.4273 34.8999 35.8004 32.9757C35.1735 31.0513 36.3512 29.0197 38.4314 28.4371C40.5116 27.8549 42.706 28.9428 43.3331 30.8669C43.96 32.7913 42.7821 34.8232 40.7022 35.4056Z",
    fill: "#90C8F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.915 27.2315C289.894 24.7666 292.036 22.7502 294.699 22.7279C297.363 22.7056 299.54 24.6858 299.561 27.1507C299.582 29.6156 297.44 31.632 294.776 31.6543C292.113 31.6766 289.936 29.6964 289.915 27.2315ZM298.799 27.1571C298.782 25.0814 296.949 23.4138 294.706 23.4326C292.462 23.4514 290.658 25.1494 290.676 27.2251C290.694 29.3008 292.527 30.9684 294.77 30.9496C297.014 30.9308 298.817 29.2327 298.799 27.1571Z",
    fill: "#90C8F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.017 55.2405C305.937 55.8227 303.742 54.7348 303.115 52.8107C302.488 50.8863 303.666 48.8547 305.746 48.272C307.827 47.6898 310.021 48.7777 310.648 50.7019C311.275 52.6263 310.097 54.6581 308.017 55.2405Z",
    fill: "#90C8F1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.557 71.0073C78.0677 71.9842 74.3864 70.1594 73.335 66.9317C72.2833 63.7037 74.2589 60.2954 77.7482 59.3185C81.2373 58.3416 84.9184 60.1664 85.9703 63.3943C87.022 66.6221 85.0461 70.0306 81.557 71.0073Z",
    fill: "#36698D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.557 71.0073C287.068 71.9842 283.386 70.1594 282.335 66.9317C281.283 63.7037 283.259 60.2954 286.748 59.3185C290.237 58.3416 293.918 60.1664 294.97 63.3943C296.022 66.6221 294.046 70.0306 290.557 71.0073Z",
    fill: "#36698D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.101 98.1583C154.021 98.7404 151.827 97.6526 151.2 95.7284C150.573 93.804 151.75 91.7724 153.831 91.1897C155.911 90.6076 158.105 91.6954 158.732 93.6196C159.359 95.544 158.181 97.5759 156.101 98.1583Z",
    fill: "#36698D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.873 112.434C226.294 112.876 224.628 112.051 224.152 110.59C223.676 109.129 224.57 107.586 226.149 107.144C227.728 106.702 229.394 107.528 229.87 108.989C230.346 110.45 229.452 111.992 227.873 112.434Z",
    fill: "#36698D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.12d67685e95c9862a1ff50f9e9dd224c.svg";
export { ForwardRef as ReactComponent };